import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { SuppliersPage } from './pages/SuppliersPage';
import { SupplierDetailPage } from './pages/SupplierDetailPage';
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SupplierBuildPlan } from './components/admin/SupplierBuildPlan';
import { ScheduleCallModal } from './components/ScheduleCallModal';
export function App() {
  const [adminOpen, setAdminOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  useEffect(() => {
    const checkHash = () => setAdminOpen(window.location.hash === '#admin');
    checkHash();
    window.addEventListener('hashchange', checkHash);
    const onSchedule = () => setScheduleOpen(true);
    window.addEventListener('aeb:open-schedule', onSchedule as EventListener);
    return () => {
      window.removeEventListener('hashchange', checkHash);
      window.removeEventListener('aeb:open-schedule', onSchedule as EventListener);
    };
  }, []);
  const closeAdmin = () => {
    history.replaceState(null, '', window.location.pathname);
    setAdminOpen(false);
  };
  return <div className="min-h-full w-full bg-white" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Navbar data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/suppliers" element={<SuppliersPage data-id="element-7" />} data-id="element-6" />
        <Route path="/suppliers/:id" element={<SupplierDetailPage data-id="element-9" />} data-id="element-8" />
        <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
        <Route path="/faq" element={<FAQPage data-id="element-13" />} data-id="element-12" />
        <Route path="/resources" element={<ResourcesPage data-id="element-15" />} data-id="element-14" />
        <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
        <Route path="*" element={<NotFoundPage data-id="element-19" />} data-id="element-18" />
      </Routes>
      <Footer data-id="element-20" />
      {adminOpen && <SupplierBuildPlan onClose={closeAdmin} data-id="element-21" />}
      <ScheduleCallModal open={scheduleOpen} onClose={() => setScheduleOpen(false)} data-id="element-22" />
    </div>;
}